export default {
  // 相机日志
  CAMERA_LOG_LIST: "/api/mini/park/log/by_road",
  //道口监控设备列表
  CAMERA_MONITOR_LIST: "/api/mini/park/road/equ/monitor",
  //单个摄像头获取流地址
  MONITOR_PULL_STREAM: "/api/mini/park/road/equ/monitor/pullStream",
  //图片抓拍
  CAMERA_PHOTO_CAPTURE: "/api/mini/b/park/auth_record/remoteCapture",
  //图片抓拍列表
  CAMERA_PHOTO_LIST: "/api/mini/park/log/captrueList",
  //手动关闸
  CLOSE_GATE: "/api/mini/b/park/auth_record/remoteCloseGate",
  //手动开闸
  OPEN_GATE: "/api/mini/b/park/auth_record/remoteOpenGate",

  // 道口摄像头列表
  ROAD_CAMERA_LIST: "/hardware/equipment/cameraList",

  // 获取视频流地址
  ROAD_VIDEO_URL: "/hardware/equipment/getAppletCameraVideoUrl"
};
